<template>
    <span class="badge" :class="[`badge--${type}`]">
        {{ text }}
    </span>
</template>

<script >
const __sfc_main = {};
__sfc_main.props = {
  text: {
    type: String,
    default: 'NEW'
  },
  type: {
    type: String,
    default: 'success',
    // success, warning, danger, info
    validator: value => ['success', 'warning', 'danger', 'info'].includes(value)
  }
};
export default __sfc_main;
</script>

<style lang="less" scoped>
.badge {
    display: inline-flex;
    height: 0.44rem;
    align-items: center;
    justify-content: center;
    padding: 0 0.15rem;
    border-radius: 0.15rem 0 0.1rem 0;
    font-size: 0.24rem;
    font-weight: 500;
    line-height: 100%;

    // 成功/绿色
    &--success {
        background-color: #00a843;
        color: #fff;
    }

    // 警告/橙色
    &--warning {
        background-color: #faad14;
        color: #fff;
    }

    // 危险/红色
    &--danger {
        background-color: #ff4d4f;
        color: #fff;
    }

    // 信息/蓝色
    &--info {
        background-color: #1890ff;
        color: #fff;
    }
}
</style>
